module.exports = __webpack_public_path__ + "img/banner_left.dbc427c3.png";